import { themeColor, themeFontFamily } from 'LibNeo/theme'
import styled from 'styled-components'

export const Label = styled.span`
	display: inline-block;
	padding: 0 8px;
	width: fit-content;
	font-family: ${themeFontFamily('SBSansInterface')};
	font-style: normal;
	font-size: 12px;
	line-height: 20px;
	font-weight: 400;
	color: ${themeColor('gray', 5)};
`
